export default "__VITE_ASSET__CNIlR683__"